import { FindWhiteLabelRes } from '../response/white-label.response';
import httpClient from '../util/http-client';

export const WhiteLabelService = {
  findWhiteLabel: async (
    businessId: string,
  ): Promise<(FindWhiteLabelRes | any)[]> => {
    let data;
    let err;
    try {
      const res = await httpClient.get(`/white-label/my-white-label`, {
        params: {
          businessId: businessId,
        },
      });
      data = res.data;
    } catch (error: any) {
      data = error.response?.data || { success: false, message: error.message };
      err = error;
    }
    return [data, err];
  },
};
